import Plan from '@/pages/Plans';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.OrganizationPlansTab = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    initialize: function() {
        this.listenTo(WiseMetering.currentOrganization, 'change', this.onModelChange.bind(this));
    },

    onShow: function() {
        const container = document.getElementById(this.id);

        if (!container) {
            console.error(`Element with id "${this.id}" not found.`);
            return;
        }

        this.reactRoot = createRoot(container);
        this.renderReactComponent();
    },

    onModelChange: function() {
        this.renderReactComponent();
    },

    renderReactComponent: function() {
        this.reactRoot.render(
            <Plan currentPlan={WiseMetering.currentOrganization.plan().toJSON()} organization={WiseMetering.currentOrganization.toJSON()}/>
        );
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount();
            this.reactRoot = null;
        }
        this.stopListening(WiseMetering.currentOrganization);
    }
});
